import isSize from '../../utils/responsive/isSize';
import Sizes from '../../utils/responsive/Sizes';

const showFullPageSheet = () => isSize(Sizes.SM);

export default showFullPageSheet;
